import styled from "styled-components";

export const MainWrapper = styled.div`
  position: relative;
  margin: 0;
  min-height: 100vh;
  width: 100vw;
  transition: 500ms opacity ease-in-out;
  @media only screen and (max-width: ${p => p.theme.break}px) {
    min-height: 95vh;
  }
`;

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1310px;
  width: 100%;
  padding: 0px 15px 0 15px !important;
`;

export const Row = styled.div`
  display: flex;
  flex: ${props => (props.flex ? props.flex : "initial")};
  flex-direction: row;
  flex-wrap: ${props => (props.wrap ? props.wrap : "initial")};
  align-content: ${props =>
    props.alignContent ? props.alignContent : "initial"};
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : "initial"};
  @media screen and (max-width: 768px) {
    flex-direction: ${props => (props.mobile ? "column" : "row")};
  }
`;
export const Column = styled.div`
  flex: ${props => (props.flex ? props.flex : "initial")};
  flex-direction: column;
  align-content: ${props =>
    props.alignContent ? props.alignContent : "initial"};
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : "initial"};
  margin: ${props => (props.margin ? props.margin : "0")};
  width: ${props => (props.width ? props.width : "auto")};
`;
